import React, { FC, useEffect } from 'react';

import clsx from 'clsx';

import { Product } from '@domains/product';

import { sendShowProductsEvent } from '@utils/analytics';

import { ProductCard } from '@components/product/ProductCard/ProductCard';

import styles from './ProductGrid.module.scss';

// Keep in mind, 4 or 5 columns here is grid size on large viewports.
// Grid itself is responsive, so there will be less cards per row
// on medium-sized and small viewports.
export type ProductGridVariant = 'fourColumns' | 'fiveColumns';

export type ProductGridProps = {
    variant: ProductGridVariant;
    priceDigit?: number;
    products: Product[];
    className?: string;
};

const variantToClassMap: Record<ProductGridVariant, string> = {
    fourColumns: styles.isVariantFourColumns,
    fiveColumns: styles.isVariantFiveColumns,
};

export const ProductGrid: FC<ProductGridProps> = (props) => {
    const { variant, className, products, priceDigit = 0 } = props;

    useEffect(() => {
        if (products.length === 0) return;
        sendShowProductsEvent(products);
    }, [products]);

    return (
        <div className={clsx(styles.root, variantToClassMap[variant], className)}>
            {products.map((product) => (
                <ProductCard key={product.slug} product={product} priceDigit={priceDigit} />
            ))}
        </div>
    );
};
